import { FindElment } from 'lib/library';
import { BRIDGE_NUMBERING, NOTATION_CONFIG } from 'lib/teeth/teethMapper';
/**
 * NOTE: teeth를 색상 입힐때사용하는 함수입니다.
 * @param {*} config
 */
function settingTeethElementFn(config) {
  // eslint-disable-next-line no-unused-vars
  const { findTag, findAttr, changeId } = config;
  return function (conf) {
    const { teeth = [], list = [] } = conf;
    const hasTeethIndexList = teeth.map(item => Number(item.number));
    // eslint-disable-next-line array-callback-return
    list.map(item => {
      const number = Number(item.number);
      // const findGtag = Array.from(
      //   document.querySelectorAll(`${findTag}[${findAttr}${item.number}"]`),
      // )[0];
      const findGtag = item.groupElement;

      if (!findGtag) return null;
      const findFillPath = findGtag.querySelector('g[data-role="teeth"] > path');
      const findPimLineFillPath = findGtag.querySelector(
        'g[data-role="teeth"] > g[data-role="pim"] > polygon',
      );
      const findPimFillPath = findGtag.querySelector(
        'g[data-role="teeth"] > g[data-role="pim"] > circle',
      );

      const findAbutmentLineFillPath = findGtag.querySelector(
        'g[data-role="teeth"] > g[data-role="abutment"] > circle',
      );

      const findAbutmentFillPath = findGtag.querySelector(
        'g[data-role="teeth"] > g[data-role="abutment"] > polygon',
      );
      const findFillTextPath = findGtag.querySelector('g[data-role="teeth"] > text');
      // const getOriginAttrFill = findGtag.getAttribute('data-origin-url');
      // NOTE: path url swap 부분
      // NOTE: 데이터가 있을때
      if (hasTeethIndexList.includes(number)) {
        const findItemInfo = teeth.find(inItem => Number(inItem.number) === number);
        const setChangeId = `${changeId}${findItemInfo?.indicationIdx}`;
        if (
          !!findItemInfo.hasPim &&
          !!findPimLineFillPath &&
          !!findPimFillPath &&
          !!findAbutmentLineFillPath &&
          !!findAbutmentFillPath
        ) {
          if (findItemInfo.pimType === 'normal') {
            findFillPath.setAttribute('fill', 'rgba(255,255,255,0.1)');
            findPimLineFillPath.setAttribute('fill', 'rgba(0,0,0,1)');
            findPimFillPath.setAttribute('fill', 'rgba(255, 255, 255,1)');
            findAbutmentLineFillPath.setAttribute('fill', 'rgba(0,0,0,0)');
            findAbutmentFillPath.setAttribute('fill', 'rgba(255, 255, 255,0)');
          } else {
            findFillPath.setAttribute('fill', 'rgba(255,255,255,0.1)');
            findPimLineFillPath.setAttribute('fill', 'rgba(0,0,0,0)');
            findPimFillPath.setAttribute('fill', 'rgba(255, 255, 255,0)');
            findAbutmentLineFillPath.setAttribute('fill', 'rgba(255,255,255,1)');
            findAbutmentFillPath.setAttribute('fill', 'rgba(144, 145, 154,1)');
          }
        } else {
          if (!!findItemInfo?.indicationIdx) {
            findFillPath.setAttribute('fill', `url(#${setChangeId})`);
          } else {
            // findFillPath.setAttribute('fill', 'rgba(0,0,0,1)');
            findFillPath.setAttribute('fill', 'rgba(255,0,0,1)');
            // findFillPath.setAttribute('fill', 'rgba(255,255,255,1)');
          }
          if (!findItemInfo?.indicationIdx || !findItemInfo?.material) {
            findFillTextPath.setAttribute('fill', 'rgba(255,0,0,1)');
          } else {
            findFillTextPath.setAttribute('fill', 'rgba(0,0,0,1)');
          }
          findGtag.classList.add('hasData');
        }
      } else {
        // NOTE: 데이터가 없을때
        findFillPath.setAttribute('fill', 'rgba(255,255,255,.1)');
        // findFillPath.setAttribute('stroke', '#000');
        // findFillPath.setAttribute('stroke-width', '1px');
        findGtag.classList.remove('hasData');
        if (
          !!findPimLineFillPath &&
          !!findPimFillPath &&
          !!findAbutmentLineFillPath &&
          !!findAbutmentFillPath
        ) {
          findPimLineFillPath.setAttribute('fill', 'rgba(0,0,0,0)');
          findPimFillPath.setAttribute('fill', 'rgba(127, 130, 148,0)');
          findFillPath.setAttribute('fill', 'rgba(255,255,255,0.1)');
          findAbutmentLineFillPath.setAttribute('fill', 'rgba(0,0,0,0)');
          findAbutmentFillPath.setAttribute('fill', 'rgba(127, 130, 148,0)');
        }
      }
    });
  };
}
/**
 *
 */
export const setTeethElement = settingTeethElementFn({
  findTag: 'g',
  findAttr: 'data-tooth-id="data-group-',
  changeId: 'swap-linear-',
});

/**
 * NOTE: 처음 teeth의 이름을 붙혀줍니다.
 * group핑하고 text 태그만 찾으면 댐, groupObj but, realDOM
  const setTeethFormat = {
    list: mergeTeethList,
    defaultValue: propsTeeth,
  };
  setBasicTeeth(setTeethFormat);
  처음에 class를 넣어주고 세팅해주는 함수. 재각각인 넘버링을 줄세워줍니다.
 * @param {*} config 
 */
export function setBasicTeeth(config) {
  const { list = [], defaultValue = [] } = config;
  // g 태그를 찾고, attr을 붙혀줌
  list.map((item, idx) => {
    const defaultIndex = NOTATION_CONFIG.fdi.list[idx];
    const findGtag = item.groupElement;

    if (findGtag) {
      const findFillPath = findGtag.querySelector('g[data-role="teeth"] > path');
      // const findFillPath = findGtag.querySelector('path[fill^="url"]');
      // const getOriginAttrFill = findGtag.getAttribute('data-origin-url');
      // const getAttiFill = findFillPath.getAttribute('fill');
      // if (!getOriginAttrFill) {
      //   findGtag.setAttribute('data-origin-url', getAttiFill);
      // }
      findGtag.setAttribute('data-name', 'tooth-g');
      findGtag.setAttribute('data-tooth-id', `data-group-${defaultIndex}`);
      findGtag.setAttribute('data-tooth-index', idx);
      findGtag.setAttribute('class', 'teethSvg__tooth');
    }
  });

  const setTeethFormat = { list, teeth: defaultValue };
  setTeethElement(setTeethFormat);

  return list;
}

/**
 * NOTE: 처음 tooth rendering 될떄 element 찾아서 넘버링순서 4분면으로 정렬
 * const convertFormat = {
     elements: Array.from(svgRef.current.querySelectorAll('tspan')),
  };
  convertToothElementToObjectList(convertFormat);
 * @param {*} config
 */
export function setMergeSortTeethElement(config) {
  const { elements = [] } = config;
  const findElement = new FindElment();
  const newMap = elements.map(item => {
    item.setAttribute('class', 'teethSvg__text');
    return {
      element: item,
      number: Number(item.textContent),
    };
  });
  // NOTE: 배열을 순회하면서 치아를 4분면으로 나눠 배열로 소팅함
  const sortNewMap = newMap
    .sort((a, b) => a.number - b.number)
    // eslint-disable-next-line array-callback-return
    .sort((prev, next) => {
      const a = prev.number;
      const b = next.number;
      switch (Math.floor(b / 10)) {
        case 1:
          return -19 + a;
        case 2:
          return -21 + b;
        case 3:
          return -39 + a;
        case 4:
          return -41 + b;
        default:
          return null;
      }
    })
    .reduce(
      (acc, curr, idx) => {
        curr.index = idx;
        const findGtag = findElement.findParent(curr.element, null, 'g');
        curr.groupElement = findGtag;
        acc[Math.floor(idx / 8)].push(curr);
        return acc;
      },
      [[], [], [], []],
    );

  const mergeNewMap = sortNewMap.reduce((acc, i) => acc.concat(i), []);
  return mergeNewMap;
}

// DEBUG: set brdige 부분하기 리얼돔 건드리는중
/**
 * NOTE: bridge의 색상을 칠하고 빼고 하는 함수입니다.
 * @param {*} config
 * @config bridge array item, teethIndexList item : String
 */
export function setBridgeElement(config) {
  let { element, bridge = [], teethIndexList = [] } = config;
  // console.log(element, 'element');

  bridge = bridge.map(String);
  // bridge = bridge.map(String);
  // console.log('bridge', bridge);
  // console.log(bridge, 'bridgebridgebridge, !!!');

  // const findBridgePath = element.querySelectorAll(`g > path[d^=M${item}][d$="11z"]`)[0];
  const findBridgePath = element.querySelectorAll(`g[data-role="bridge"] > *`);
  // console.log(findBridgePath, 'findBridgePath');
  Array.from(findBridgePath).map((item, idx) => {
    const bridgeNubmer = BRIDGE_NUMBERING[idx];
    // console.log('bridgeNubmer', bridgeNubmer);
    // console.log('bridgeNubmer.split(/(d{2})(?=d)/)', bridgeNubmer.split(/(\d{2})(?=\d)/));
    // console.log('bridgeNubmer.split(/(d{2})(?=d)/)', bridgeNubmer.split(/(\d{2})/));
    const isPosibleClickBridge = String(bridgeNubmer)
      .split(/(\d{2})(?=\d)/)
      .slice(1)
      .map(String)
      .every(item => teethIndexList.indexOf(item) !== -1);
    // console.log('teethIndexList', teethIndexList);
    // console.log('isPosibleClickBridge', isPosibleClickBridge);
    const hasBridge = bridge.indexOf(String(bridgeNubmer)) !== -1;
    if (hasBridge) {
      item.classList.add('bridge-active');
      item.classList.remove('hidden');
      item.removeAttribute('hidden');
    } else {
      item.classList.remove('bridge-active');
    }
    if (isPosibleClickBridge) {
      item.classList.remove('bridge-disabled');
    } else {
      item.classList.add('bridge-disabled');
      item.classList.remove('bridge-active');
    }
  });
}

/**
 * DEBUG: 사용중,
 * DEBUG: 확장적으로 수정해야함, 일단 함수 정리를 위해 빼놈
 * NOTE: 처음에 bridge의 클래스와 세팅을 해주는 함수입니다.
 * @param {*} config
 */
export function setBasicBridge(config = {}) {
  const { element, defaultValue = [], isEdit = null, teethIndexList = [] } = config;
  let bridgeList = [];
  const findBridgePath = element.querySelectorAll(`g[data-role="bridge"] > *`);
  // console.log(findBridgePath, 'findBridgePath');

  Array.from(findBridgePath).map((item, idx) => {
    // console.log(item, 'item');
    const bridgeNubmer = BRIDGE_NUMBERING[idx];
    const hasBridge = defaultValue.indexOf(bridgeNubmer) !== -1;

    item.setAttribute('class', 'teethSvg__brdige bridge-disabled');
    item.setAttribute('data-bridge-id', `data-bridge-${BRIDGE_NUMBERING[idx]}`);
    item.setAttribute('data-bridge-index', idx);
    item.setAttribute('data-name', 'tooth-bridge');

    if (!isEdit) {
      item.classList.add('view');
      if (!hasBridge) {
        item.classList.add('hidden');
        item.setAttribute('hidden', 'true');
      } else {
        item.classList.remove('hidden');
        item.removeAttribute('hidden');
      }
    }

    bridgeList.push({
      element: item,
      number: Number(item.getAttribute('data-bridge-id').replace(/\D/g, '')),
      index: idx,
    });
  });

  const setBrdigeFormat = {
    element,
    bridge: defaultValue,
    teethIndexList: teethIndexList,
  };
  setBridgeElement(setBrdigeFormat);

  return bridgeList;
}
